import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogomarkForLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 27,
	viewBox: "0 0 22 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7958 26.2253L15.5713 14.4671L20.3478 8.59741L20.7777 26.2441L15.7958 26.2253Z",
			fill: "#033099"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.96759 26.2253L5.07267 20.6096L0.429887 15.563L0 26.2253H4.96759Z",
			fill: "#033099"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.03754 11.8523L0.32959 6.15659V12.6989L5.85126 18.578C6.07287 18.7995 6.33832 18.9738 6.63114 19.0902C6.92397 19.2066 7.23794 19.2626 7.55362 19.2546C7.86931 19.2467 8.17997 19.175 8.46638 19.0441C8.7528 18.9131 9.00886 18.7256 9.21871 18.4933L21.289 4.23295L21.4418 0L9.20438 11.9604C8.76283 12.3451 8.18824 12.5483 7.59905 12.5282C7.00986 12.508 6.45096 12.2661 6.03754 11.8523V11.8523Z",
			fill: "#FA6450"
		})
	]
});
export default SvgLogomarkForLight;
